'use strict';

require('angular');
window._ = require('lodash');

/**
 * Bootstrap our application by calling the bootstrap partial.
 */

import './bootstrap';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import './utility/sidebar-toggle';

dayjs.extend(relativeTime);

if (document.querySelector('#navigation')) require('./navigation');
if (document.querySelector('#companyinfo')) require('./company');

var clickableSearchOptions = document.querySelectorAll(".recent-query.clickable");

for (var i=0; i<clickableSearchOptions.length; i++) {
  clickableSearchOptions[i].addEventListener('click', function () {
    document.querySelector('#q').value = this.dataset.query;
    try {
      document.querySelector('#header-search-form').submit();
    }
    catch(err) {
      document.querySelector('#index-search-form').submit();
    }
  });
}


/**
 * Next we will register the CSRF Token as a common header so that
 * all outgoing HTTP requests automatically have it attached.
 */
 window.CSRF_TOKEN = document.head.querySelector('meta[name="csrf-token"]').content;
 
 window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
 window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.CSRF_TOKEN;
 

 
 window.app = angular.module('ab', []);
//app.controller('root', ['$scope','$http','$timeout', function ($scope,$http,$timeout) {
//    $scope.newsletter_modal = false;
//    $scope.newsletter_email = '';
//    $scope.newsletter_success = false;
//
//    $scope.newsletterSignUp = function(){
//        let email = document.getElementById('newsletter_email').value;
//        $http.post('/newsletter/subscribe', {email: email})
//            .success(function(response) {
//              $scope.newsletter_success = true;
//              $timeout(function(){
//                $scope.closeNewsletter();
//              },3000)
//            });
//    };
//
//    $scope.closeNewsletter = function(){
//      $scope.newsletter_modal = false;
//      $http.post('/newsletter/hide')
//        .success(function(response) {
//
//        });
//    };
//
//    $timeout(function(){
//      $scope.newsletter_modal = true;
//    },5000)
//}]);

require('./controllers/general');
require('./controllers/cookies');
require('./controllers/header');


 
